const MB = 1024 * 1024;
const MAX_SIZE = 50 * MB;
const OVER_SIZE_MESSAGE = "50MB以上のファイルはアップロードできません。";

export default class UploadFileProject {
  errors: string[] = [];

  isSatisfied(file: File) {
    this.errors = [];
    if (file.size > MAX_SIZE) {
      this.errors.push(OVER_SIZE_MESSAGE);
    }
    return !this.errors.length;
  }
}
